import { render, staticRenderFns } from "./MPNResearchDetailDialog.vue?vue&type=template&id=42ca68ca&scoped=true"
import script from "./MPNResearchDetailDialog.vue?vue&type=script&lang=js"
export * from "./MPNResearchDetailDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42ca68ca",
  null
  
)

export default component.exports